import React from 'react';

const ProcAdm2 = props => {



    return (
        <div></div>
    )
}

export default ProcAdm2